module.exports = "../fonts/hotel_cradle_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hotel_cradle_icon.svg
// module id = 440
// module chunks = 0